import { defineComponent, ref, useModel, openBlock, createElementBlock, Fragment, createVNode, unref, withModifiers, withCtx, renderList, normalizeClass, createElementVNode, toDisplayString, createCommentVNode, normalizeStyle, createBlock, mergeModels, nextTick, toRaw } from 'vue';
import { ElForm, ElInput, ElButton } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
import InfiniteScroll from '../../../component/infinite-scroll/infinite-scroll.js';
import _sfc_main$1 from '../../../component/player/player.vue.js';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { Search } from '@element-plus/icons-vue';
import { SelectList, ListWrapper } from '@ssml-editor/vue';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { VoiceContentData } from './data.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "voice-content",
  props: /* @__PURE__ */ mergeModels({
    storageType: {},
    storeName: {},
    reader: { type: Function },
    saver: { type: Function },
    categoryPageSize: { default: 10 },
    voicePageSize: { default: 10 },
    fetchVoices: { type: Function, default: () => Promise.resolve([]) },
    fetchCategories: { type: Function, default: () => Promise.resolve([]) },
    searchVoices: { type: Function }
  }, {
    "modelValue": {
      default: new VoiceContentData()
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const showSearchResult = ref(false);
    const showVoiceList = ref(false);
    const searchInput = ref("");
    const categoryDataList = ref([]);
    const voiceDataList = ref([]);
    const searchVoiceDataList = ref([]);
    const searchSelectedVoice = ref({});
    const voiceContentData = useModel(__props, "modelValue");
    function searchInputHandler(value) {
      if (value.trim() === "") {
        showSearchResult.value = false;
        searchVoiceDataList.value = [];
      } else {
        showSearchResult.value = true;
      }
    }
    function categoryValueChangeHandler() {
      showVoiceList.value = false;
      nextTick(() => {
        showVoiceList.value = true;
      });
    }
    async function fetchVoiceList(page) {
      const voices = await __props.fetchVoices({
        page,
        category: voiceContentData.value.categoryValue
      });
      return voices.map((item) => ({
        label: item.name,
        value: item.value,
        src: item.src
      }));
    }
    async function categoryChangeHandler(categoryData) {
      showVoiceList.value = false;
      if (categoryData.length > 0) {
        categoryDataList.value = categoryData;
        if (!voiceContentData.value.categoryValue || !categoryData.some(
          (item) => item.value === voiceContentData.value.categoryValue
        )) {
          voiceContentData.value.categoryName = categoryData[0].label;
          voiceContentData.value.categoryValue = categoryData[0].value;
        }
        nextTick(() => {
          showVoiceList.value = true;
        });
      }
    }
    async function voiceChangeHandler(voiceData) {
      if (voiceData.length > 0) {
        voiceDataList.value = voiceData;
        if (!voiceContentData.value.voiceValue || !voiceData.some(
          (item) => item.value === voiceContentData.value.voiceValue
        )) {
          voiceContentData.value.voiceName = voiceData[0].label;
          voiceContentData.value.voiceValue = voiceData[0].value;
          voiceContentData.value.voiceSrc = voiceData[0].src;
        }
      }
    }
    async function searchSubmitHandler() {
      searchVoiceDataList.value = [];
      const voices = __props.searchVoices ? await __props.searchVoices({
        word: searchInput.value
      }) : [];
      if (voices.length > 0) {
        searchVoiceDataList.value = voices.map((item) => ({
          label: item.name,
          value: item.value,
          src: item.src
        }));
        searchSelectedVoice.value = {
          ...voices[0]
        };
      }
    }
    function voiceSelectHandler(item) {
      voiceContentData.value.voiceName = item.label;
      voiceContentData.value.voiceValue = item.value;
      voiceContentData.value.voiceSrc = item.src;
    }
    function voiceSearchSelectHandler(item) {
      searchSelectedVoice.value = {
        name: item.label,
        value: item.value,
        src: item.src
      };
    }
    function getData() {
      if (showSearchResult.value) {
        return {
          voiceName: searchSelectedVoice.value?.name,
          voiceValue: searchSelectedVoice.value?.value,
          voiceSrc: searchSelectedVoice.value?.src
        };
      } else {
        return toRaw(voiceContentData.value);
      }
    }
    __expose({
      getData
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.searchVoices ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "se-voice-content-search"
        }, [
          createVNode(unref(ElForm), {
            onSubmit: withModifiers(searchSubmitHandler, ["prevent"])
          }, {
            default: withCtx(() => [
              createVNode(unref(ElInput), {
                modelValue: searchInput.value,
                "onUpdate:modelValue": ($event) => searchInput.value = $event,
                placeholder: "搜索音色",
                clearable: "",
                onInput: searchInputHandler
              }, {
                append: withCtx(() => [
                  createVNode(unref(ElButton), {
                    onClick: searchSubmitHandler,
                    icon: unref(Search)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          showSearchResult.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "se-voice-content-search-result"
          }, [
            createVNode(unref(SelectList), {
              modelValue: searchSelectedVoice.value.value,
              "onUpdate:modelValue": ($event) => searchSelectedVoice.value.value = $event,
              "data-list": searchVoiceDataList.value
            }, {
              default: withCtx(({ model, dataList }) => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(dataList, (item, index) => {
                  return openBlock(), createElementBlock("p", {
                    class: normalizeClass(["se-voice-item", { activated: item.value === model }]),
                    title: item.label,
                    key: index,
                    onClick: ($event) => voiceSearchSelectHandler(item)
                  }, [
                    createVNode(unref(_sfc_main$1), {
                      src: item.src
                    }, null, 8, ["src"]),
                    createElementVNode("span", { class: "se-text" }, toDisplayString(item.label), 1)
                  ], 10, ["title", "onClick"]);
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue", "data-list"])
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "se-voice-content-body",
          style: normalizeStyle({ display: showSearchResult.value ? "none" : "flex" })
        }, [
          createVNode(unref(ListWrapper), { title: "类型" }, {
            default: withCtx(() => [
              createVNode(unref(InfiniteScroll), {
                modelValue: voiceContentData.value.categoryValue,
                "onUpdate:modelValue": [($event) => voiceContentData.value.categoryValue = $event, categoryValueChangeHandler],
                "page-size": __props.categoryPageSize,
                load: __props.fetchCategories,
                onChange: categoryChangeHandler
              }, null, 8, ["modelValue", "onUpdate:modelValue", "page-size", "load"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), { title: "音色" }, {
            default: withCtx(() => [
              showVoiceList.value ? (openBlock(), createBlock(unref(InfiniteScroll), {
                key: 0,
                modelValue: voiceContentData.value.voiceValue,
                "onUpdate:modelValue": ($event) => voiceContentData.value.voiceValue = $event,
                "page-size": __props.voicePageSize,
                load: fetchVoiceList,
                onChange: voiceChangeHandler
              }, {
                default: withCtx(({ model, dataList }) => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(dataList, (item, index) => {
                    return openBlock(), createElementBlock("p", {
                      class: normalizeClass(["se-voice-item", { activated: item.value === model }]),
                      title: item.label,
                      key: index,
                      onClick: ($event) => voiceSelectHandler(item)
                    }, [
                      createVNode(unref(_sfc_main$1), {
                        src: item.src
                      }, null, 8, ["src"]),
                      createElementVNode("span", { class: "se-text" }, toDisplayString(item.label), 1)
                    ], 10, ["title", "onClick"]);
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue", "page-size"])) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 4)
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=voice-content.vue.js.map
